import { Button, colors, Container, Divider, Stack, TextField, Typography } from '@mui/material';
import React from 'react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import Cookies from 'universal-cookie';
import CryptoJS from 'crypto-js';
import _ from 'lodash';
import DialogLoading from '../../components/DialogLoading';
import { fetchWith401Check } from '../../helpers/http';
import BackIcon from '@mui/icons-material/ArrowBack';

const API_URL = process.env.REACT_APP_STAGE === 'DEVELOPMENT' ? process.env.REACT_APP_API_HOST : process.env.REACT_APP_API_HOST_PROD;

const Auth = () => {
  const [state, setState] = React.useState({ username: '', password: '' });
  const cookies = new Cookies();
  const navigate = useNavigate();
  const [loadingProps, setLoadingProps] = React.useState({ show: false, title: 'Loading ...', description: 'Please wait' });

  const doLogin = () => {
    if (!state.username) return toast.error('Please input username');
    if (!state.password) return toast.error('Please input password');

    // end of validation

    const secretKey = process.env.REACT_APP_SKEY;
    const encrypted = CryptoJS.AES.encrypt(state.password, secretKey).toString();

    const body = {
      username: state.username,
      password: encrypted,
    };

    try {
      setLoadingProps({ ...loadingProps, show: true });
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      };
      fetchWith401Check(`${API_URL}/auth/login`, requestOptions)
        .then(function (response) {
          if (response.ok) {
            return response.json();
          }
          return Promise.reject(response);
        })
        .then(function (response) {
          cookies.set('token', response.response, { path: '/' });
          toast.success('Success');
          navigate('/portal');
        })
        .catch(function (err) {
          return toast.error('Username/password not found');
        })
        .finally(function () {
          setLoadingProps({ ...loadingProps, show: false });
        });
    } catch (error) {
      toast.error(error.message);
    }
  };
  return (
    <div style={{ backgroundColor: colors.blue[200], minHeight: '100vh' }}>
      <Container maxWidth='sm'>
        <Stack p={4} direction='column' sx={{ backgroundColor: 'white', minHeight: '100vh' }} spacing={2}>
          <Typography variant='h4'>User login</Typography>
          <Typography variant='body2'>Please input your credential below</Typography>
          <Divider />
          <TextField
            id='username'
            label='Username'
            value={state.username}
            defaultValue=''
            variant='filled'
            onChange={(e) => setState({ ...state, username: e.currentTarget.value })}
          />
          <TextField
            type='password'
            id='password'
            label='Password'
            value={state.password}
            defaultValue=''
            variant='filled'
            onChange={(e) => setState({ ...state, password: e.currentTarget.value })}
          />
          <Button variant='outlined' onClick={doLogin}>
            Login
          </Button>
          <Stack direction='row' sx={{ width: '100%' }} alignItems='center' spacing={1} justifyContent='center'>
            <Divider sx={{ flex: 1 }} />
            <Typography variant='body2'>or</Typography>
            <Divider sx={{ flex: 1 }} />
          </Stack>
          <Stack direction='row' justifyContent='center'>
            {/* <Typography variant='body2' sx={{ fontWeight: 'bold', cursor: 'pointer' }} onClick={() => navigate('/register')}>
              
            </Typography> */}
            <Button variant='contained' onClick={() => navigate('/register')}>
              Register
            </Button>
          </Stack>
          <Stack direction='row' spacing={1} sx={{ cursor: 'pointer' }} onClick={() => navigate('/')}>
            <BackIcon color='primary' />
            <Typography variant='body2'>Back to dashboard repositories</Typography>
          </Stack>
        </Stack>
      </Container>
      <DialogLoading props={loadingProps} />
    </div>
  );
};

export default Auth;
